import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryGrid from './components/CategoryGrid';
import SEOContent from './components/SEOContent';
import Footer from './components/Footer';
import JsonLd from '@/components/feature/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://basetaosheet.wtf';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Basetao Spreadsheet Hub',
  url: siteUrl,
  description: 'The ultimate Basetao Spreadsheet resource hub with verified guides, product reviews, shipping cost calculators, warehouse tips, coupons and expert insights.',
  potentialAction: {
    '@type': 'SearchAction',
    'target': {
      '@type': 'EntryPoint',
      urlTemplate: `${siteUrl}/?s={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Basetao Spreadsheet Hub',
  url: siteUrl,
  description: 'The complete Basetao Spreadsheet guide, review and shopping resource platform.',
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <JsonLd data={websiteSchema} />
      <JsonLd data={organizationSchema} />
      <Navbar />
      <Hero />
      <CategoryDropdown />
      <CategoryGrid />
      <SEOContent />
      <Footer />
    </main>
  );
}